<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <router-link to="/" title="OG WhatsApp — ogbwhats.com" rel="home">
          <img class="header-image is-logo-image" alt="OG WhatsApp logo" src="../assets/og-whatsapp-logo.png" title="OG WhatsApp">
        </router-link>
      </div>
      <p class="main-title" itemprop="headline">
        <router-link to="/" rel="home">
          OG WhatsApp
        </router-link>
      </p>
    </div>
    <ul v-show="isMenuClicked" id="menu-primary-menu" class="menu sf-menu mobile-menu-page">
      <!-- <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-13 current_page_item menu-item-32">
        <router-link :to="{ name: `${selectedLanguage}-gb` }" exact>{{ this.translation[selectedLanguage].home }}</router-link>
      </li> -->
      <li id="menu-item-home" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home">
        <router-link :to="{ name: 'en-og' }" exact>
Home
</router-link>
      </li>
      <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <router-link class="download-btn" :to="{ name: 'en-download' }">
Download
</router-link>
      </li>
      <li id="menu-item-compare" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <router-link :to="{ name: 'en-compare-og-gb' }">
OG VS GB WhatsApp
</router-link>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div v-if="$global.isMobileDevice()" class="mobile-menu">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img v-if="!isMenuClicked" src="@/assets/menu.svg" alt="menu button">
          <img v-else src="@/assets/xmark-black.svg" alt="close button">
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <!-- <li id="menu-item-32" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-13 current_page_item menu-item-32">
          <router-link :to="{ name: `${selectedLanguage}-gb` }" exact>{{ this.translation[selectedLanguage].home }}</router-link>
        </li> -->
        <li id="menu-item-home-pc" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home">
          <router-link :to="{ name: 'en-og' }" exact>
Home
</router-link>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <router-link class="download-btn" :to="{ name: 'en-download' }">
Download
</router-link>
        </li>
        <li id="menu-item-compare" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <router-link :to="{ name: 'en-compare-og-gb' }">
OG VS GB WhatsApp
</router-link>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import Search from './Search.vue';
export default {
  components: {
    Search,
  },
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'ar',
          val: '🇦🇪 اَلْعَرَبِيَّةُ'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  methods: {
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

/* 深色顶栏下：菜单/关闭图标反白 */
.mobile-menu .menu-toggle img {
  filter: brightness(0) invert(1);
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #204f46;

        a, div {
          font-size: 15px;
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
